var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7C3.167 7 2 5.833 2 4.5S3.167 2 4.5 2 7 3.167 7 4.5 5.833 7 4.5 7zM11.128 8.342a1 1 0 0 1 1.696.03l4.267 7.114A1 1 0 0 1 16.234 17H2.057a1 1 0 0 1-.786-1.618l3.405-4.333a1 1 0 0 1 1.6.037l1.606 2.25 3.246-4.994z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik00LjUgN0MzLjE2NyA3IDIgNS44MzMgMiA0LjVTMy4xNjcgMiA0LjUgMiA3IDMuMTY3IDcgNC41IDUuODMzIDcgNC41IDd6TTExLjEyOCA4LjM0MmExIDEgMCAwIDEgMS42OTYuMDNsNC4yNjcgNy4xMTRBMSAxIDAgMCAxIDE2LjIzNCAxN0gyLjA1N2ExIDEgMCAwIDEtLjc4Ni0xLjYxOGwzLjQwNS00LjMzM2ExIDEgMCAwIDEgMS42LjAzN2wxLjYwNiAyLjI1IDMuMjQ2LTQuOTk0eiIvPjwvc3ZnPg==";
export { SvgImage18 as ReactComponent };